import { render, staticRenderFns } from "./RangeMembershipsModule.vue?vue&type=template&id=96881340"
import script from "./RangeMembershipsModule.vue?vue&type=script&lang=js"
export * from "./RangeMembershipsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports